export default __webpack_public_path__ + "files/1_1_4_SWOT_template_per_factor.docx";